{
  "buttons": {
    "confirm": {
      "text": "Send Now",
      "textPending": "Sending"
    }
  }
}
